<template>
  <v-dialog transition="scale-transition" origin="center center" max-width="460" v-model="dialogDeposit"
    content-class="deposit-withdraw-popup marketingPopup">
    <template v-slot:activator="{ on, attrs }">
      <span class="text-decoration-none" v-bind="attrs" v-on="on">Change MT5 Password</span>
    </template>
    <v-card class="rounded-0 pa-7" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
      <v-card-title class="pb-3 text-left justify-start pl-3">
        Change MT5 Password
      </v-card-title>
      <v-card-subtitle class="mt-0 pl-3 pb-0 pr-10 text--ash">
        Change your trading account password from here
      </v-card-subtitle>
      <v-card class="deposit-form px-3 py-4" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
        <v-row>
          <v-col cols="12">
            <fieldset>
              <legend>MT5 Account</legend>
              <v-select v-model="trading_account_no" :items="formattedMT5Accounts" item-text="text" item-value="value"
                solo append-icon="mdi-chevron-down" label="Click to Select" class="custom-select"
                hide-details></v-select>
            </fieldset>
          </v-col>
          <v-col cols="12">
            <fieldset>
              <legend>Current Password</legend>
              <v-text-field label="Write New Password" v-model="current_password"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :type="show1 ? 'text' : 'password'" counter
                @click:append="show1 = !show1" single-line solo hide-details class="custom-select"></v-text-field>
            </fieldset>
          </v-col>
          <v-col cols="12">
            <fieldset>
              <legend>New Password</legend>
              <v-text-field v-model="password" :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show2 ? 'text' : 'password'" counter @click:append="show2 = !show2"
                label="Write New Password Again" single-line solo hide-details class="custom-select"></v-text-field>
            </fieldset>
          </v-col>
          <v-col cols="12">
            <fieldset>
              <legend>Confirm Password</legend>
              <v-text-field v-model="confirm_password" :append-icon="show3 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show3 ? 'text' : 'password'" counter @click:append="show3 = !show3"
                label="Write New Password Again" single-line solo hide-details class="custom-select"></v-text-field>
            </fieldset>
          </v-col>
        </v-row>
      </v-card>
      <v-card-actions>
        <v-row dense>
          <v-col cols="12">
            <v-btn tile @click="changeLeverage" elevation="0" class="text-capitalize btn-account mr-3 px-sm-8"
              color="greenMain">Confirm</v-btn>
            <v-btn tile color="#FF567F" @click="dialogDeposit = false" elevation="0"
              class="text-capitalize btn-account px-sm-8">Cancel</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { REGISTERUSERDETAILS__ACTIONS } from "@/store/action-types";

export default {
  data() {
    return {
      dialogDeposit: false,
      show1: false,
      show2: false,
      show3: false,
      trading_account_no: '',
      password: "",
      current_password: "",
      confirm_password: ""

    };
  },
  computed: {
    ...mapState("reguserdetails", ["mt5Accounts"]),
    formattedMT5Accounts() {
      return this.mt5Accounts.map(account => ({
        text: account.trading_account_no,
        value: account.trading_account_no
      }));
    },

  },
  methods: {
    ...mapActions("reguserdetails", [REGISTERUSERDETAILS__ACTIONS.CLIENTMT5ACCOUNTANDTYPES, REGISTERUSERDETAILS__ACTIONS.CHANGECLIENTPASSWORD]),

    async changeLeverage() {
      await this[REGISTERUSERDETAILS__ACTIONS.CHANGECLIENTPASSWORD]({
        trading_account_no: this.trading_account_no,
        password: this.password,
        current_password: this.current_password,
        confirm_password: this.confirm_password,
      });
      this.dialogDeposit = false;
      this.trading_account_no = "";
      this.password = "";
      this.current_password = "";
      this.confirm_password = "";
    },
  },
  async mounted() {
    this.userId = this.$route.params.id
    await this[REGISTERUSERDETAILS__ACTIONS.CLIENTMT5ACCOUNTANDTYPES](this.$route.params.id);
  },
};
</script>